import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { NavigationService } from "@tylertech/core-module";
import { RouterHelpers } from "@tylertech/shared-module";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { IntentService } from "../../services";

@Component({
    selector: "intent-resolver",
    templateUrl: "./intentResolver.tmpl.html",
    standalone: false
})
export class IntentResolverComponent
    implements OnDestroy, OnInit
{
    private readonly destructor$ = new Subject<void>();

    private routeMIME: string;
    private routeAction: string;
    private routeData: string;

    constructor(
        activatedRoute: ActivatedRoute,
        private readonly navigationService: NavigationService,
        private readonly intentService: IntentService)
    {
        activatedRoute.paramMap
            .pipe(takeUntil(this.destructor$))
            .subscribe((paramMap: ParamMap) =>
            {
                this.routeMIME = RouterHelpers.tryGetParam(paramMap, "mime");
                this.routeAction = RouterHelpers.tryGetParam(paramMap, "action");
                this.routeData = RouterHelpers.tryGetParam(paramMap, "data");
            });
    }

    ngOnDestroy(): void
    {
        this.destructor$.next();
        this.destructor$.complete();
    }

    ngOnInit(): void
    {
        try
        {
            const data = JSON.parse(decodeURIComponent(this.routeData));
            this.intentService.resolve(this.routeMIME, this.routeAction, data)
                .then(() =>
                {
                    this.navigationService.redirectToDashboard();
                });
        }
        catch
        {
            /* Squashing error  */
            this.intentService.resolve(this.routeMIME, this.routeAction, {})
                .then(() =>
                {
                    this.navigationService.redirectToDashboard();
                });
        }
    }
}
